export default __webpack_public_path__ + "static/media/1415 knife block A top.05fbbb5f.png";